import './TrackmanEvents.scss';

import OnDemandRecordings from 'components/TrackmanEvents/OnDemandRecordings/OnDemandRecordings';
import Separator from 'components/Separator/Separator';
import UpcomingEvents from 'components/TrackmanEvents/UpcomingEvents/UpcomingEvents';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const TrackmanEvents = observer(() => {
  const tes = useStores().trackmanEventsStore;
  const ps = useStores().profileStore;
  const { t } = useTranslation();

  useSetPageTitle({
    title: t('Events', { ns: 'trackmanEvents' }),
    subtitle: t('StayUpdatedAboutUpcomingEvents', { ns: 'trackmanEvents' }),
  });

  useEffect(() => {
    tes.getTrackmanEvents();
  }, [tes]);

  useEffect(() => {
    ps.checkIfUserIsMember();
  }, [ps]);

  return (
    <div className='trackman-events-wrapper'>
      <UpcomingEvents />
      {tes.upcomingEventsList.length ? <Separator /> : null}
      <OnDemandRecordings />
    </div>
  );
});

export default TrackmanEvents;
